/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentNoteText/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import NoteHtml from 'DesignSystem/NoteHtml/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function AppointmentNoteText({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Appointment/Notes/Content/AppointmentNoteText"
  
}) {
let eventAppointmentNoteNoteValueData = fromData.useDataValue({ viewPath,
context: 'event_appointment_note',
path: 'note',
})
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
  return (<React.Fragment
>
<NoteHtml
  viewPath={`${viewPath}/NoteHtml`}
 fontSize={dtTypographyFontsizeM}
 lineHeight={16}
 data="event_appointment_note.note"
 html={eventAppointmentNoteNoteValueData}
/>
{children}
</React.Fragment>)
}